import assocGroupStyles from '../components/assocGroupStyles';

const hh = 'calc(100vh - 64px)';

const facePageStyles = (theme) => ({
  ...assocGroupStyles(theme),
  entityProfileFrame_title: {
    fontFamily: 'MetricWebBold',
    fontSize: '1.3rem',
  },
  entityProfileFrame_subtitleName: {
    maxWidth: '45%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  summonVobFormDiv: {
    textAlign: 'right',
    marginRight: '3px',
  },
  leftColumn: {
    padding: '8px',
    height: hh,
    backgroundColor: 'white',
    overflowY: 'auto',
  },
  rightColumn: {
    height: hh,
    backgroundColor: 'white',
    overflowY: 'auto',
  },
  activityColumn: {
    backgroundColor: '#eaf0f2',
    padding: '10px 15px 0',
    [theme.breakpoints.up('lg')]: {
      height: hh,
      overflowY: 'auto',
    },
  },
  u_ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  u_cursorPointer: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

export default facePageStyles;
